import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { PageType, TimeFilter } from 'src/app/models/enums';
import { IEventResult } from 'src/app/models/results/eventResult.interface';
import { ViewConfigurations } from 'src/app/models/util/viewConfigurations';
import { EventsService } from 'src/app/services/events.service';
import { QueryParamsService } from 'src/app/services/http/queryParams.service';
import { LoaderService } from 'src/app/services/loader.service';
import { NotificationService } from 'src/app/services/notification.service';
import { SportsService } from 'src/app/services/sports.service';
import { UtilityService } from 'src/app/services/util/utility.service';

@Component({
  selector: 'app-results',
  templateUrl: './results.component.html',
  styleUrls: ['./results.component.less']
})
export class ResultsComponent{

  pageType: PageType;
  // showStream = false;
  expandedEventResult: IEventResult = null;
  pageTypeEnum = PageType;
  isMobileView = false;

  // testing
  menu: any;
  buttons: any;
  lists: any;

  loading: boolean;
  timeFilterValue: TimeFilter;
  timeFilterValueEnum = TimeFilter;
  viewConfigurations = ViewConfigurations;

  protected subscription: Subscription = new Subscription();

  constructor(
    protected route: ActivatedRoute,
    protected utilityService: UtilityService,
    protected eventsService: EventsService,
    protected notificationService: NotificationService,
    protected sportsService: SportsService,
    protected loaderService: LoaderService,
    protected queryParamService: QueryParamsService) {
    this.subscription.add(this.eventsService.expandedEventResult$.subscribe((ev) => this.expandedEventResult = ev));

    // this.eventsService.showStream$.subscribe((x) => this.showStream = x);

    this.isMobileView = this.utilityService.mobileView;

    this.subscription.add(this.sportsService.timeFilterChanged$.subscribe((x) => this.timeFilterValue = x));


  }

}
